import { createApp } from "vue";
import App from "./App.vue";
import "./assets/tailwind.css";
import "@fortawesome/fontawesome-free/css/all.css";
import Vue3TouchEvents from "vue3-touch-events";

const app = createApp(App);
app.use(Vue3TouchEvents);
app.mount("#app");
